import ProgressBar from '@shared/components/progress-bar/progress-bar';
import styles from './loading-screen.module.less';
import { useState } from 'react';
import {
	useOnAssetLoadStart,
	useOnAssetLoadProgress,
	useOnAssetLoadComplete,
} from '@game';

function LoadingScreen() {
	const [showProgress, setShowProgress] = useState(false);
	const [progress, setProgress] = useState(0);

	useOnAssetLoadStart(() => {
		setShowProgress(true);
		setProgress(0);
	});

	useOnAssetLoadProgress(({ progress }) => {
		setProgress(progress);
	});

	useOnAssetLoadComplete(() => {
		setTimeout(() => {
			setShowProgress(false);
		}, 500);
	});

	if (!showProgress) {
		return <></>;
	}

	return (
		<div className={styles.screen}>
			<div className={styles.content}>
				<ProgressBar
					value={progress}
					color="blue"
					size="large"
					dark
					className={styles.bar}
				/>
				<span className={styles.percent}>{Math.round(progress * 100)}%</span>
			</div>
		</div>
	);
}

export default LoadingScreen;
